import './Home.css';
import { useNavigate } from 'react-router-dom';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import profileImage from '../JASMIN.png';

function Home() {
  const navigate = useNavigate();

  const scrollToAbout = () => {
    navigate('/about');
  };

  return (
    <section className="home">
      <div className="home-container">
        <div className="home-content">
          <h1 className="home-title">Jasmin Meghan<br/>R. Malolos</h1>
          <h2 className="home-subtitle">
            Computer Engineering Student <span className="divider">|</span> 
            <span className="highlight"> Aspiring Software Developer</span>
          </h2>
          <p className="home-tagline">
            3rd Year – Bachelor of Science in Computer Engineering<br/>
            <span className="school-name">FAITH Colleges</span>
          </p>
          <p className="home-description">
            A passionate Computer Engineering student dedicated to developing innovative solutions through technology. 
            With a growing foundation in both hardware and software systems, I continuously explore new tools, 
            programming practices, and engineering concepts to build efficient and meaningful digital solutions.
          </p>
          <div className="home-buttons">
            <button className="btn btn-primary" onClick={scrollToAbout}>
              Learn More About Me
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/resume')}>Resume</button>
          </div>
          <div className="social-links">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" title="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-icon" title="GitHub">
              <FaGithub />
            </a>
            <a href="mailto:jasmin@example.com" className="social-icon" title="Email">
              <FaEnvelope />
            </a>
          </div>
        </div>
        <div className="home-image">
          <img src={profileImage} alt="Jasmin Meghan R. Malolos" className="profile-img"/>
        </div>
      </div>
    </section>
  );
}

export default Home;
